import BaseTransitionConverter from '@src/slide/domain/ui-model/element-modeles/transition/converter/base';
import { DeepReadonly } from 'ts-essentials';
import { IFlipTransition } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { SwitchDirection } from '@src/slide/domain/ui-model/element-modeles/transition/direction/switch-direction';
import { ICTSlideTransition, STTransitionLeftRightDirectionType } from '@tencent/slide-sdk-pb-model';
import {
    invertMapping,
    switchDirectionSdkMapping,
} from '@src/slide/domain/ui-model/element-modeles/transition/type-mapping';
import { DeepPartial } from '@src/slide/infrastructure/module/independent/ts-tools/deep-partial';

export default class FlipConverter extends BaseTransitionConverter {
    public convertPartialSdkToUi(
        sdkData: DeepReadonly<ICTSlideTransition>,
        uiData: IFlipTransition,
    ) {
        super.convertPartialSdkToUi(sdkData, uiData);

        const sdkDir = sdkData.flip?.dir as STTransitionLeftRightDirectionType;
        uiData.direction = new SwitchDirection(switchDirectionSdkMapping[sdkDir]);
    }

    public convertPartialUiToSdk(uiData: DeepPartial<IFlipTransition>, sdkData: ICTSlideTransition) {
        super.convertPartialUiToSdk(uiData, sdkData);

        const sdkFlip = sdkData.flip || {};
        if (uiData.direction?.data) {
            sdkFlip.dir = invertMapping(switchDirectionSdkMapping)[uiData.direction.data];
        }

        sdkData.flip = sdkFlip;
    }
}
